import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { IPaymentGatewayTransactionDetails } from '@boma/shared/entities';

@Injectable({ providedIn: 'root' })
export class PaymentsService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  createOrderBatchTransaction(entityId: string, batchId: string) {
    return this.httpClient.post<IPaymentGatewayTransactionDetails>(
      `${this.base}api/v${this.version}/checkout/${entityId}/orderbatch/${batchId}`,
      {}
    );
  }

  createOrderTransaction(entityId: string, orderId: string) {
    return this.httpClient.post<IPaymentGatewayTransactionDetails>(
      `${this.base}api/v${this.version}/checkout/${entityId}/order/${orderId}`,
      {}
    );
  }
}
